import { Control, Controller, FieldErrors, FieldPath, FieldValues, get } from 'react-hook-form';

import { Checkbox } from 'primereact/checkbox';
import { classNames } from 'primereact/utils';

export type FormCheckboxProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = {
  className?: string;
  control: Control<TFieldValues>;
  errors: FieldErrors<TFieldValues>;
  field: TName;
  label: string;
  disabled?: boolean;
};

const FormCheckbox = <TFieldValues extends FieldValues>({ ...props }: FormCheckboxProps<TFieldValues>): JSX.Element => {
  const { className, control, field, errors, label, disabled } = props;

  const errorTemplate = () => {
    const error = get(errors, field);
    return error && <small className="p-error">{error?.message as string}</small>;
  };

  return (
    <div className={className ?? 'field-checkbox'}>
      <Controller
        name={field}
        control={control}
        render={({ field: formField, fieldState }) => (
          <>
            <div className="flex align-items-center">
              <Checkbox
                id={formField.name}
                onChange={(e) => formField.onChange(e.checked)}
                checked={formField.value}
                disabled={disabled}
                className={classNames({ 'p-invalid': fieldState.error })}
              />
              <label
                htmlFor={formField.name}
                className={classNames('ml-2 font-medium', {
                  'p-error': fieldState.error,
                  disabled,
                })}
              >
                {label}
              </label>
            </div>
          </>
        )}
      />
      {errorTemplate()}
    </div>
  );
};

export default FormCheckbox;
